import { Link } from 'react-router-dom';
import { LOGO_MINI } from '@/lib/brand';
import { footerStyles } from './Footer.styles';

export type FooterLink = {
  to: string;
  label: string;
};

export type FooterProps = {
  appTitle: string;
  links: FooterLink[];
  copyright: string;
};

export function Footer({ appTitle, links, copyright }: FooterProps): JSX.Element {
  return (
    <footer className={footerStyles.root}>
      <div className={footerStyles.inner}>
        <div className={footerStyles.brand}>
          <img src={LOGO_MINI} alt={appTitle} className={footerStyles.logo} />
          <span className="font-heading text-heading-sm">{appTitle}</span>
        </div>
        <nav className={footerStyles.links} aria-label="Footer">
          {links.map((link) => (
            <Link key={link.to} to={link.to} className={footerStyles.link}>
              {link.label}
            </Link>
          ))}
        </nav>
        <p className={footerStyles.copy}>{copyright}</p>
      </div>
    </footer>
  );
}
